import { PaginateQuery } from "core/resources/types/shared";
import { TimelineLog } from "components/TimelineLogs";

export interface EquipamentoDto {
  id: string;
  dataCompra: string;
  local: string;
  marca?: { id: string; nome: string };
  nome: string;
  observacao?: string | null;
}

export interface EquipamentoArquivo {
  id: string;
  nome: string;
  referencia: string;
  mimetype: string;
}

export interface EquipamentoForm {
  id?: string;
  nome: string;
  marcaId?: string;
  local?: string;
  areaComumId?: string;
  anoFabricacao?: string;
  dataCompra?: string;
  dataInstalacao: string;
  observacao?: string;
  arquivos?: (File | EquipamentoArquivo)[];
  tipoLocalEquipamentoId: string;
}

export enum TipoLocalEquipamentoEnum {
  Outros = "DD04913A-1C46-4EBE-BFB3-F311EE9E0000",
  AreaComum = "DD04913A-1C46-4EBE-BFB3-F311EE9E0001",
}

export interface HistoricoEquipamentoLogs extends TimelineLog {}

export interface FiltroEquipamentos extends PaginateQuery {
  local?: string;
  areaComumId?: string;
  tipoLocalEquipamento?: TipoLocalEquipamentoEnum;
}
